export default {
  "productPhotos": { "unsavedTitle":"Salva i tuoi cambiamenti?","unsavedBody":"Salvare o scartare l'impostazione della foto del prodotto prima di lasciare questo modello.","save":"Salva","discard":"Cartolina","cancel":"Annulla","saveFailed":"Le modifiche non potrebbero essere salvate. La vostra impostazione in sospeso è stata mantenuta. Si prega di riprovare.","label": "Mostra le foto del prodotto", "help": "Utilizza le foto già salvate contro i prodotti. Salvare il layout per mantenere questa impostazione." },
  "copy0": "L'uso della ricetta può essere inserito in unità compatibili con",
  "copy1": "Nessun riscontro trovato.",
  "copy2": "Nome",
  "copy3": "Bar principale",
  "copy4": "Tipo di uscita",
  "copy5": "Selezionare il tipo di uscita",
  "copy6": "Menù disponibili in questo outlet",
  "copy7": "Selezionare ogni menu che questa presa può servire, quindi scegliere un menu predefinito.",
  "copy8": "ordinazione pubblica abilitata",
  "copy9": "Modalità di servizio",
  "copy10": "Selezionare la modalità di servizio",
  "copy11": "Servizio rapido",
  "copy12": "Servizio di Tabella",
  "copy13": "Selezione della tabella",
  "copy14": "Selezionare il requisito",
  "copy15": "Obbligatorio",
  "copy16": "Facoltativo",
  "copy17": "Aree di pranzo",
  "copy18": "Creare aree pranzo prima di assegnarle qui.",
  "copy19": "Posizione dell'inventario",
  "copy20": "Posizione facoltativa",
  "copy21": "Nessuna posizione",
  "copy22": "Uscita attiva",
  "copy23": "Abilitare o disabilitare questo outlet.",
  "copy24": "Annulla",
  "copy25": "Salvare l'outlet",
  "copy26": "Cena della sala da pranzo",
  "copy27": "Assegnazione di uscita",
  "copy28": "Assegna questo menu alle prese dalle impostazioni Outlet.",
  "copy29": "Menu attivo",
  "copy30": "Nascondi o pubblica questo menu.",
  "copy31": "Abilitare per il servizio in camera",
  "copy32": "Pubblicare questo menu a schermi in camera.",
  "copy33": "Supplemento (%)",
  "copy34": "Tassa di consegna",
  "copy35": "Il sovraccarico si applica a ogni elemento di questo menu. La tassa di consegna si applica una volta per ordine in una fase successiva.",
  "copy36": "Articoli da menu",
  "copy37": "Aggiornare le voci di riga che appaiono su questo menu.",
  "copy38": "Etichetta di pulsante",
  "copy39": "Nome dell'articolo",
  "copy40": "Dimensione del pacchetto",
  "copy41": "Costo",
  "copy42": "Prezzo di vendita",
  "copy43": "Azioni",
  "copy44": "Non c'è ancora menu.",
  "copy45": "Singola",
  "copy46": "0,00",
  "copy47": "Menù duplicato",
  "copy48": "Salva il menu",
  "copy49": "Rimuovere la voce del menu?",
  "copy50": "Rimuovi",
  "copy51": "da questo menu.",
  "copy52": "Selezionare una presa per generare un link di lancio.",
  "copy53": "Link di lancio",
  "copy54": "URL di uscita sicuro + rotazione OTP .",
  "copy55": "URL di uscita",
  "copy56": "Codice di accesso una volta",
  "copy57": "Scadenze in",
  "copy58": "Codice QR in attesa",
  "copy59": "Scansione per aprire il terminale",
  "copy60": "Rigenerare segreto terminale",
  "copy61": "Accesso al personale POS",
  "copy62": "Personale del club di assegnare al cassiere PIN login. PIN hashes rimanere lato server e vecchi PIN non sono mai mostrati.",
  "copy63": "Ricerca personale assegnato...",
  "copy64": "Aggiungere il personale",
  "copy65": "Assegnato",
  "copy66": "Set PIN",
  "copy67": "Ultimo accesso:",
  "copy68": "Livello di autorizzazione",
  "copy69": "Standard",
  "copy70": "Migliorata",
  "copy71": "Generare / ripristinare PIN",
  "copy72": "Rimuovi da ePOS",
  "copy73": "Accesso all'uscita",
  "copy74": "Tutte le prese",
  "copy75": "Questo membro del personale può accedere ad ogni uscita POS.",
  "copy76": "Nessun personale è assegnato a ePOS.",
  "copy77": "Aggiungi ePOS personale",
  "copy78": "Selezionare uno o più membri del club attivo. Assegnazione non cambia il proprio account personale di base.",
  "copy79": "Ricerca personale ammissibile...",
  "copy80": "Assegnazione selezionata",
  "copy81": "Nuovo POS PIN",
  "copy82": "Questo PIN è mostrato solo una volta, non può essere recuperato più tardi.",
  "copy83": "Copia PIN",
  "copy84": "Fine",
  "copy85": "non ha il modulo di gestione ePOS abilitato.",
  "copy86": "Configurazione guidata",
  "copy87": "Creare outlet",
  "copy88": "Crea menu",
  "copy89": "Prese attive",
  "copy90": "Punti vendita in tempo reale che accettano gli ordini.",
  "copy91": "Menù attivi",
  "copy92": "Menù assegnati alle prese e abilitati.",
  "copy93": "Pulsanti configurati",
  "copy94": "Pulsanti configurati nel menu selezionato.",
  "copy95": "Punti vendita a colpo d'occhio",
  "copy96": "Salta rapidamente in link di lancio e stato.",
  "copy97": "Non ci sono ancora prese",
  "copy98": "Crea il tuo primo outlet per iniziare a costruire menu.",
  "copy99": "Collegamento di lancio",
  "copy100": "Punti vendita",
  "copy101": "Aggiorna",
  "copy102": "Gestisci le posizioni di servizio e le impostazioni predefinite.",
  "copy103": "Organizza un bar, una sala da pranzo o un negozio professionale.",
  "copy104": "Aggiornato",
  "copy105": "Modificare l'output",
  "copy106": "Dettagli di uscita",
  "copy107": "Menu predefinito e mappature di inventario.",
  "copy108": "Menu predefinito",
  "copy109": "Uscita",
  "copy110": "Posizione dell'inventario",
  "copy111": "Scorte",
  "copy112": "Menù",
  "copy113": "Assegnare i menu alle prese e tenerli aggiornati.",
  "copy114": "Nessun menu ancora",
  "copy115": "Crea il tuo primo menu e inizia ad aggiungere pulsanti.",
  "copy116": "Selettore menu",
  "copy117": "Seleziona un menu",
  "copy118": "punti vendita)",
  "copy119": "Modifica menu",
  "copy120": "Duplicare",
  "copy121": "Costruttore di menu",
  "copy122": "Progettare la griglia del pulsante per il menu selezionato.",
  "copy123": "Articolo",
  "copy124": "configurato.",
  "copy125": "Scegliere un menu per avviare la configurazione dei pulsanti.",
  "copy126": "Tutti i prodotti ePOS attivi",
  "copy127": "Sfoglia, filtrare, spuntare più prodotti, quindi aggiungerli insieme.",
  "copy128": "Aggiungi Selezionato",
  "copy129": "Prodotti di ricerca rapidi...",
  "copy130": "Categoria",
  "copy131": "Ricerca di articoli...",
  "copy132": "Aggiunto",
  "copy133": "Pulsanti",
  "copy134": "I pulsanti del menu non possono caricare.",
  "copy135": "Questo menu non ha pulsanti",
  "copy136": "Cerca i prodotti ePOS attivi sopra, quindi tocca Aggiungi per costruire la tua griglia POS.",
  "copy137": "Aggiungi articoli",
  "copy138": "Registrazione degli oggetti mancante dall'inventario.",
  "copy139": "Oggetto inattivo o non vendibile.",
  "copy140": "ePOS Prodotti",
  "copy141": "I prodotti sono ciò che i soci e gli ospiti acquistano alla cassa; le ricette maneggiano il consumo di magazzino.",
  "copy142": "Creare un prodotto",
  "copy143": "I prodotti sono temporaneamente non disponibili.",
  "copy144": "Nome del prodotto*",
  "copy145": "Nome del prodotto",
  "copy146": "ad esempio Carling Pint",
  "copy147": "Scorto Beer",
  "copy148": "Prezzo di vendita indicato al socio/ospite",
  "copy149": "Prezzo di vendita",
  "copy150": "6,50",
  "copy151": "Il prezzo di vendita comprende VAT ?",
  "copy152": "Sì",
  "copy153": "No",
  "copy154": "Codice fiscale",
  "copy155": "Elemento di stock collegato (solo convenienza consigliata)",
  "copy156": "Selezionare la voce stock",
  "copy157": "Nessun elemento di ricetta collegato",
  "copy158": "Immagine del prodotto",
  "copy159": "Caricamento immagine prodotto",
  "copy160": "Inviare a KDS / richiede preparazione",
  "copy161": "La predefinizione è fuori per la sicurezza. I prodotti contrassegnati come che richiedono KDS utilizzano regole di routing.",
  "copy162": "Categoria di Prep",
  "copy163": "Modifica in Inventario",
  "copy164": "Modifica",
  "copy165": "Disattivare",
  "copy166": "Creare la ricetta",
  "copy167": "Nessun prodotto ePOS",
  "copy168": "Crea Carling Pint, Bottiglia di Coca, Cheeseburger, e altri fino a pulsanti qui.",
  "copy169": "Ricette",
  "copy170": "Le ricette definiscono quali oggetti di inventario vengono consumati quando un prodotto POS viene venduto.",
  "copy171": "Le ricette sono temporaneamente non disponibili.",
  "copy172": "Scegliere un prodotto e definire lo stock consumato per vendita.",
  "copy173": "Annulla modifica",
  "copy174": "Prodotto*",
  "copy175": "Selezionare il prodotto ePOS",
  "copy176": "Cerca prodotti per nome, SKU , codice articolo, categoria, sottocategoria, o unità...",
  "copy177": "Ingredienti / inventario consumato",
  "copy178": "Aggiungere ingrediente",
  "copy179": "Articolo con gestione scorte",
  "copy180": "Cerca articoli stock per nome, SKU , codice articolo, categoria, sottocategoria, o unità...",
  "copy181": "Quantità consumata",
  "copy182": "568",
  "copy183": "Modifica delle linee",
  "copy184": "Non ci sono ricette",
  "copy185": "Utilizzare la procedura guidata di configurazione o creare un prodotto, quindi definire quale azione consuma.",
  "copy186": "Transazioni ePOS",
  "copy187": "Ordini operativi/check/tab e registri di vendita/pagamento completati con tracciabilità dell'inventario.",
  "copy188": "Data di transazione da",
  "copy189": "Data di transazione a",
  "copy190": "Presa di transazione",
  "copy191": "Stato di transazione",
  "copy192": "Stato",
  "copy193": "Stato di default",
  "copy194": "Ordini attivi",
  "copy195": "Apri",
  "copy196": "Pagamento anticipato",
  "copy197": "Inviato in cucina",
  "copy198": "Non pagato",
  "copy199": "Pagato / completato",
  "copy200": "Voi stessi",
  "copy201": "Rimborsato",
  "copy202": "Annullato",
  "copy203": "Ricerca delle transazioni",
  "copy204": "Ricerca vendita, tavolo, prodotto",
  "copy205": "Rimuovere i filtri",
  "copy206": "Ordini",
  "copy207": "Vendite",
  "copy208": "Caricamento delle transazioni...",
  "copy209": "Vedi il dettaglio",
  "copy210": "Nessun ordine operativo trovato per i filtri selezionati.",
  "copy211": "Nessuna vendita completa trovata per i filtri selezionati.",
  "copy212": "Caricamento in dettaglio...",
  "copy213": "Numero",
  "copy214": "Tabella",
  "copy215": "Personale / cassiere",
  "copy216": "Totale",
  "copy217": "Subtotale",
  "copy218": "Imposta",
  "copy219": "Articoli di linea",
  "copy220": "Q",
  "copy221": "Nessun elemento di linea registrato.",
  "copy222": "Pagamenti",
  "copy223": "Nessun pagamento registrato.",
  "copy224": "Riepilogo creditizio",
  "copy225": "Originale",
  "copy226": "• Eccezionale",
  "copy227": "Riepilogo dell'assegnazione dei pagamenti",
  "copy228": "Impatto dell'account",
  "copy229": "Ripartizione fiscale",
  "copy230": "GL sommario",
  "copy231": "Debiti",
  "copy232": "Crediti",
  "copy233": "Dr. Dr.",
  "copy234": "• Cr",
  "copy235": "Riassunto del consumo dell'inventario",
  "copy236": "Quantità",
  "copy237": "• Quantità di ricetta",
  "copy238": "Modifica del prodotto ePOS",
  "copy239": "Aggiornare i dettagli del prodotto fino ai soci e agli ospiti.",
  "copy240": "Modifica nome del prodotto",
  "copy241": "Modifica prezzo di vendita",
  "copy242": "Elemento di riserva collegato",
  "copy243": "Nessun link diretto",
  "copy244": "Anteprima del prodotto",
  "copy245": "Nessuna immagine",
  "copy246": "Modifica l'immagine del prodotto",
  "copy247": "I prodotti contrassegnati come che richiedono KDS saranno inviati al primo percorso attivo corrispondente.",
  "copy248": "Attivo / vendibile",
  "copy249": "Salvare il prodotto",
  "copy250": "Disattivare il prodotto?",
  "copy251": "Questo rimuove il prodotto dalla selezione ePOS attiva, ma mantiene la sua storia.",
  "copy252": "Inventario / ePOS Setup Wizard",
  "copy253": "Oggetto stock = quello che il club compra/stores. ePOS prodotto = quello che il socio/ospite compra. Ricetta = quanto stock viene consumato per vendita, ad esempio magazzino un keg 30 L, vendere una pinta, e consumare 568 ml da keg stock.",
  "copy254": "Cosa stai organizzando?",
  "copy255": "Il mago è deterministico: utilizza solo i campi sottostanti. I suggerimenti assistiti dall'IA sono disponibili in seguito dietro la bandierina delle funzioni disabilitate.",
  "copy256": "Nome dell'articolo stock*",
  "copy257": "ad es. 30 L birra keg",
  "copy258": "SKU / codice a barre / codice articolo",
  "copy259": "Birra",
  "copy260": "Unità di acquisto",
  "copy261": "Quantità di acquisto / dimensione",
  "copy262": "30.",
  "copy263": "Unità di misura di acquisto",
  "copy264": "Prezzo di costo del fornitore",
  "copy265": "10.",
  "copy266": "L'acquisto di codice fiscale",
  "copy267": "Codice fiscale facoltativo id",
  "copy268": "nome del prodotto ePOS*",
  "copy269": "ad es. prodotto Pint",
  "copy270": "Comprende un'unità di azione per la vendita?",
  "copy271": "Sì, consumare 1 ciascuno",
  "copy272": "No, definirò le linee di ricetta",
  "copy273": "Dimensione di servizio consumata",
  "copy274": "Unità di servizio",
  "copy275": "Prodotti ePOS esistenti*",
  "copy276": "Selezionare il prodotto",
  "copy277": "Ricetta ingredienti",
  "copy278": "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1",
  "copy279": "Creare la configurazione",
  "copy280": "Vendita attuale",
  "copy281": "Tabella delle assegnazioni",
  "copy282": "Cancella",
  "copy283": "Rimuovi l'elemento selezionato",
  "copy284": "Articoli",
  "copy285": "VAT inclusi",
  "copy286": "Paga",
  "copy287": "Terminale POS",
  "copy288": "La vendita attuale è chiara?",
  "copy289": "Cancella la vendita",
  "copy290": "Questo rimuoverà l'assegnazione della tabella corrente e sgombererà la vendita da questo terminale.",
  "copy291": "Trasferimenti in cucina",
  "copy292": "Chiudi",
  "copy293": "Note di prepunta",
  "copy294": "Aggiungere le note di prep (opzionale)",
  "copy295": "Fuoco ora",
  "copy296": "Entrata manuale del codice a barre",
  "copy297": "Scanner USB/Bluetooth e voce manuale supportata.",
  "copy298": "Chiudi voce codice a barre",
  "copy299": "Scansione o tipo di codice a barre",
  "copy300": "Scanner di messa a fuoco",
  "copy301": "Ultima scansione:",
  "copy302": "· Aggiunto",
  "copy303": "Bloccaggio",
  "copy304": "Registrazione del personale",
  "copy305": "Staff Login — Inserisci il tuo codice a 4 cifre per l'accesso",
  "copy306": "Personale PIN",
  "copy307": "Elimina",
  "copy308": "Personale:",
  "copy309": "Opzioni terminali aperte",
  "copy310": "Opzioni terminali",
  "copy311": "Chiudi opzioni terminali",
  "copy312": "Scegliere se estrarre l'attuale membro del personale o bloccare questo terminale.",
  "copy313": "Esecuzione",
  "copy314": "Schermo di bloccaggio",
  "copy315": "Menu menu menu",
  "copy316": "Tavole",
  "copy317": "Aprire la voce del codice a barre manuale",
  "copy318": "Scansione / codici a barre",
  "copy319": "Selezionare una tabella per iniziare.",
  "copy320": "Modalità di visualizzazione della tabella",
  "copy321": "Mattonelle",
  "copy322": "Piano terra",
  "copy323": "Nessuna zona pranzo assegnata a questo outlet.",
  "copy324": "Non ci sono ancora tavoli in questa zona.",
  "copy325": "Occupazione",
  "copy326": "Pagamento",
  "copy327": "Totale Due",
  "copy328": "Carta di carta",
  "copy329": "Paga (Card Present)",
  "copy330": "Contanti",
  "copy331": "Fissare istantaneo",
  "copy332": "Socio",
  "copy333": "Lettore simulato (modalità di prova)",
  "copy334": "Preparare la nuova vendita...",
  "copy335": "//",
  "copy336": "· Aggiornato",
  "copy337": "Assegnato:",
  "copy338": "Pubblicazione",
  "copy339": "Archivia",
  "copy340": "Modifica modello",
  "copy341": "Gestisci i dettagli del modello, lo stato del ciclo di vita e la sicurezza di assegnazione di uscita.",
  "copy342": "Nome del modello",
  "copy343": "Descrizione",
  "copy344": "Dimensione del terminale predefinito",
  "copy345": "Punti vendita assegnati",
  "copy346": "Cancellare un modello disattiva queste assegnazioni prima della rimozione, quindi le prese in modo sicuro rientrano nel loro prossimo modello disponibile o menu legacy.",
  "copy347": "Rimuovi dalla pubblicazione e salva come bozza",
  "copy348": "Ripristinare la bozza",
  "copy349": "Elimina il modello",
  "copy350": "Salva",
  "copy351": "Eliminare il modello POS",
  "copy352": "Confermare la rimozione di questo modello POS Screen Designer.",
  "copy353": "Modello:",
  "copy354": "Eventuali assegnazioni di uscita attive per questo modello saranno disattivate prima che il modello venga eliminato.",
  "copy355": "I link del modello del bambino e i riferimenti di lineage copiati-template saranno staccati in modo che i modelli correlati rimangano disponibili.",
  "copy356": "Cartella ·",
  "copy357": "Articolo",
  "copy358": "W+",
  "copy359": "W...",
  "copy360": "H+",
  "copy361": "H...",
  "copy362": "Privana Assistente",
  "copy363": "Privana Assist POS istruzioni per il layout",
  "copy364": "Descrivere lo schermo POS che si desidera costruire o migliorare...",
  "copy365": "Progettare...",
  "copy366": "Inviare",
  "copy367": "Privana sta progettando lo schermo...",
  "copy368": "Revisione e raffinazione dei vostri prodotti, pagine e layout touch.",
  "copy369": "Proposta pronta per la revisione",
  "copy370": "Proposta di revisione",
  "copy371": "Rigenerare",
  "copy372": "Cambiare i prodotti",
  "copy373": "Annullare la proposta pendente",
  "copy374": "Annulla proposta",
  "copy375": "Scegli i prodotti per questa schermata POS",
  "copy376": "Selezionare fino a 100 prodotti per Privana Assist per organizzare.",
  "copy377": "Ricerca di prodotti",
  "copy378": "Ricerca per nome del prodotto, SKU o codice a barre",
  "copy379": "prodotto",
  "copy380": "mostrato",
  "copy381": "Selezionare visibile",
  "copy382": "Selezione chiara",
  "copy383": "Non sono disponibili prodotti ePOS idonei.",
  "copy384": "Nessun prodotto corrisponde alla tua ricerca.",
  "copy385": "di 100 selezionati",
  "copy386": "Questa conferma usa il modello e i prodotti selezionati. La generazione non è ancora iniziata.",
  "copy387": "Mi ottimizzerò per:",
  "copy388": "Obiettivo del progetto",
  "copy389": "(opzionale)",
  "copy390": "Indietro",
  "copy391": "Cambiare il tipo di vendita al dettaglio",
  "copy392": "Perché Privana ha raccomandato questo layout",
  "copy393": "Fiducia del layout",
  "copy394": "Raccomandazione",
  "copy395": "Modalità:",
  "copy396": "Dispositivo:",
  "copy397": "Rimozione",
  "copy398": "pagine,",
  "copy399": "nodi e nodi",
  "copy400": "Pulsanti.",
  "copy401": "Perché Privana lo ha progettato in questo modo",
  "copy402": "Strumenti di progettazione dello schermo POS",
  "copy403": "Espandere design sidebar",
  "copy404": "Barra laterale espandibile",
  "copy405": "Editor schermata punto vendita",
  "copy406": "Costruire schermi touch-first dai vostri prodotti dal vivo e menu.",
  "copy407": "Collasso designer sidebar",
  "copy408": "Barra laterale di ricaduta",
  "copy409": "Strumenti di design",
  "copy410": "Crea un modello",
  "copy411": "Generare l'avviamento dai menu",
  "copy412": "Le assegnazioni di uscita superano il fallback di tutti gli outlet.",
  "copy413": "Assegna a tutti i punti vendita",
  "copy414": "Assegnazione",
  "copy415": "Pagine",
  "copy416": "Su.",
  "copy417": "Giù",
  "copy418": "Collegato da",
  "copy419": "pulsante della cartella",
  "copy420": "; l'eliminazione li fa cadere di nuovo al layout auto nodo bambino.",
  "copy421": "Prodotti",
  "copy422": "Cartelle",
  "copy423": "Pulsante pieghevole",
  "copy424": "Arrivo presto",
  "copy425": "Contenuto dinamico",
  "copy426": "Proprietà",
  "copy427": "Tema, layout e impostazioni del pulsante/nodo selezionate.",
  "copy428": "Sfondo tematico",
  "copy429": "Pulsante selezionato",
  "copy430": "Colore dei bottoni",
  "copy431": "x",
  "copy432": "#",
  "copy433": "#",
  "copy434": ",",
  "copy435": "Nulla selezionato",
  "copy436": "Selezionare un pulsante di tela o un nodo di navigazione per modificare le sue proprietà.",
  "copy437": "Nodo selezionato",
  "copy438": "Pagina progettata",
  "copy439": "Nessuna pagina progettata",
  "copy440": "Chiave d'azione",
  "copy441": "Chiave di sorgente dinamica",
  "copy442": "Cartella del bambino",
  "copy443": "Prodotto per bambini",
  "copy444": "Eliminare il nodo",
  "copy445": "Albero di navigazione",
  "copy446": "Spazio di lavoro su tela POS",
  "copy447": "Modifica delle azioni",
  "copy448": "Pagina",
  "copy449": "Salvare il layout",
  "copy450": "griglia visibile ·",
  "copy451": "righe scorrevoli",
  "copy452": "Inizia a costruire questa pagina",
  "copy453": "Trascinare un elemento dalla Biblioteca sulla tela.",
  "copy454": "Stato della tela",
  "copy455": "colonne",
  "copy456": "righe visibili",
  "copy457": "righe logiche",
  "copy458": "Vita privata",
  "copy459": "socio (opzionale)",
  "copy460": "Attaccare un socio per l'attribuzione & ricevute.",
  "copy461": "Applicato",
  "copy462": "Numero socio",
  "copy463": "Piano di carico...",
  "copy464": "Centro tabella selezionata",
  "copy465": "Centro selezionato",
  "copy466": "Zoom piano piano",
  "copy467": "Piano di montaggio",
  "copy468": "Adattamento",
  "copy469": "Zoom in piano",
  "copy470": "Piano piano tavolo stato leggenda",
  "copy471": "Disponibile",
  "copy472": "Selezionato",
  "copy473": "Non collegato",
  "copy474": "Zona",
  "copy475": "Riepilogo zona chiusa",
  "copy476": "Sedili",
  "copy477": "Non ci sono tavoli collegati in questa zona",
  "copy478": "Questo piano non ha ancora tavoli visivi collegati. Piastrelle sono ancora disponibili.",
  "extra0": "Bar",
  "extra1": "Ceneri",
  "extra2": "Negozio Pro",
  "extra3": "Casa a metà strada",
  "extra4": "Questo articolo",
  "extra5": " o ",
  "extra6": "Sì",
  "extra7": "No",
  "extra8": "Self-service tramite codice QR",
  "extra9": "Pagamento",
  "extra10": "Solo",
  "extra11": "Semplice prodotto acquistato e venduto as-is",
  "extra12": "Bozza di birra / bevanda misurata",
  "extra13": "Ricetta / prodotto alimentare",
  "extra14": "Scegli una modalità di configurazione.",
  "extra15": "Il nome dell'oggetto dell'inventario è richiesto.",
  "extra16": "Selezionare un prodotto ePOS esistente.",
  "extra17": "Il nome del prodotto è richiesto.",
  "extra18": "Il prezzo di vendita deve essere zero o superiore.",
  "extra19": "La quantità di consumo deve essere superiore a zero.",
  "extra20": "Aggiungere almeno un ingrediente della ricetta o passare al consumo uno a uno.",
  "extra21": "Aggiungere almeno un ingrediente di ricetta.",
  "extra22": "Selezionare l'opzione",
  "extra26": "Modificare l'impostazione",
  "extra27": "Creare Outlet",
  "extra28": "Menù non legato",
  "extra29": "Attivo",
  "extra30": "Inattivo",
  "extra31": "Posizione dell'inventario",
  "extra32": "Non è possibile caricare le voci del menu",
  "extra33": "Supplemento non valido",
  "extra34": "Il pagamento deve essere compreso tra 0 e 100.",
  "extra35": "Costo di consegna non valido",
  "extra36": "La quota di consegna deve essere 0 o superiore.",
  "extra37": "Menu voce aggiornata",
  "extra38": "Non è possibile aggiornare la voce del menu",
  "extra39": "Elemento di menu rimosso",
  "extra40": "Non è possibile rimuovere la voce del menu",
  "extra41": "Modifica menu",
  "extra42": "Crea menu",
  "extra43": "Salva",
  "extra44": "questo articolo",
  "extra45": "Outlet link non pronto",
  "extra46": "Copia l'URL di uscita",
  "extra47": "In grado di caricare il personale POS",
  "extra48": "Riprova.",
  "extra49": "Incapace di caricare il personale idoneo",
  "extra50": "Incapace di assegnare il personale",
  "extra51": "Incapace di salvare l'accesso del personale",
  "extra52": "Incapace di reset PIN",
  "extra53": "PIN copiato",
  "extra54": "Condividi in modo sicuro con il membro del personale.",
  "extra55": "Abilitato",
  "extra56": "Disabilitato",
  "extra57": "Membro del personale del club",
  "extra59": "Mai",
  "extra60": "Disabilita",
  "extra61": "Abilita",
  "extra62": "Selezionare il prodotto",
  "extra63": "Ricetta pronta",
  "extra64": "Nessuna ricetta",
  "extra65": "Selezionare la voce stock",
  "extra66": "Vi prego di riprovare a breve.",
  "extra67": "Incapace di caricare le prese",
  "extra68": "Incapace di caricare i menu",
  "extra69": "Non è in grado di caricare gli articoli estratti da magazzino",
  "extra70": "Aree di inventario non disponibili",
  "extra71": "Aree di pranzo non disponibili",
  "extra72": "Ricerca fallita",
  "extra76": "Uscita aggiornata",
  "extra77": "Uscita creata",
  "extra78": "Incapace di salvare l'uscita",
  "extra79": "Menu aggiornato",
  "extra80": "Menu creato",
  "extra81": "Incapace di salvare il menu",
  "extra82": "Menu duplicato",
  "extra83": "Duplica fallito",
  "extra84": "Nome del prodotto richiesto",
  "extra85": "Prezzo di vendita deve essere zero o superiore",
  "extra86": "Prodotto creato",
  "extra87": "Incapace di creare il prodotto",
  "extra88": "Prodotto aggiornato",
  "extra89": "Non è possibile aggiornare il prodotto",
  "extra90": "Prodotto disattivato",
  "extra91": "Questo prodotto è attualmente utilizzato su un menu. Rimuoverlo dai menu prima di disattivare, o riprovare dopo l'aggiornamento del menu.",
  "extra92": "Incapace di disattivare il prodotto",
  "extra93": "Seleziona un prodotto.",
  "extra94": "Aggiungere almeno una linea di ricetta.",
  "extra95": "Selezionare un prodotto a stock-tracked.",
  "extra96": "Inserire una quantità maggiore di zero.",
  "extra97": "Selezionare un'unità.",
  "extra98": "Le linee duplicate dell'ingrediente/unità non sono supportate.",
  "extra100": "Ricetta validazione fallito",
  "extra101": "Fissare i campi di ricetta evidenziati.",
  "extra102": "Ricetta aggiornata",
  "extra103": "Ricetta salvata",
  "extra104": "Incapace di salvare la ricetta",
  "extra105": "Nessun nuovo elemento selezionato",
  "extra106": "Le voci selezionate sono già su questo menu.",
  "extra107": "Articoli aggiunti al menu",
  "extra108": "Non è possibile aggiungere elementi selezionati",
  "extra109": "Non è possibile aggiornare l'etichetta",
  "extra110": "Non è possibile eliminare la voce del menu",
  "extra111": "Incapace di riordinare",
  "extra112": "Incapace di prendere OTP",
  "extra113": "Segreto terminale rigenerato",
  "extra114": "Incapace di rigenerare il segreto",
  "extra115": "Incapace di caricare le transazioni ePOS.",
  "extra116": "Incapace di caricare i dettagli delle transazioni.",
  "extra117": "Questo club",
  "extra118": "Senza titolo",
  "extra119": "Terminale di uscita aperto",
  "extra121": "Non impostato",
  "extra122": "Non collegato",
  "extra123": "Menù non firmato",
  "extra124": "Ricetta ricetta",
  "extra125": "Magazzino collegato",
  "extra126": "Ancora nessuna ricetta",
  "extra127": "prodotto ePOS",
  "extra129": "Articolo senza nome",
  "extra130": "Categoria di prodotto",
  "extra131": "Codice fiscale",
  "extra132": "Cibo",
  "extra133": "Bevande",
  "extra134": "Dolcetto",
  "extra135": "Cucina",
  "extra136": "Altro",
  "extra137": "Gestito da Inventory",
  "extra138": "Consumatori 1 unità di azione",
  "extra139": "Sella",
  "extra140": "Modificare le linee della ricetta",
  "extra141": "Creare la ricetta",
  "extra142": "Ricetta di aggiornamento",
  "extra143": "Salvare la ricetta",
  "extra144": "Uscita",
  "extra145": "Aperto",
  "extra146": "Stato",
  "extra147": "Subtotale",
  "extra148": "Imposta",
  "extra149": "Totale",
  "extra150": "Personale",
  "extra151": "Azione",
  "extra152": "Ospite",
  "extra153": "Vendita",
  "extra154": "Ora",
  "extra155": "Prodotti venduti",
  "extra156": "Q",
  "extra157": "Grosso",
  "extra158": "Rete di rete",
  "extra159": "Inventario",
  "extra160": "Contabilità",
  "extra161": "Dettaglio vendita POS",
  "extra162": "Dettaglio ordine punto vendita",
  "extra163": "Riepilogo della vendita operativa con i pagamenti, l'adempimento e lo stato contabile.",
  "extra164": "Riepilogo ordine/controllo operativo per il personale e i manager.",
  "extra165": "Socio",
  "extra166": "Vendita per",
  "extra167": "socio / ospite",
  "extra168": "Articolo",
  "extra169": "Allocazione Voificata",
  "extra170": "Allocato",
  "extra171": "Tassa di soggiorno",
  "extra172": "GL conto",
  "extra173": "Articolo",
  "extra174": "Comprese",
  "extra175": "Modifica della categoria di prodotti",
  "extra176": "Modifica del codice fiscale",
  "extra177": "La convalida guidata di configurazione non è riuscita",
  "extra178": "Setup creato",
  "extra179": "La procedura guidata di configurazione non è riuscita",
  "extra180": "Tavolo non trovato. Rifiuti tavoli e riprovare.",
  "extra181": "Vendita non trovata per questo tavolo occupato. Rifiuti tavoli e riprovare.",
  "extra182": "Questa tabella ha già una vendita aperta. Rifiutare i tavoli e aprire la vendita esistente.",
  "extra183": "La tabella occupata mancava di un documento di vendita e il recupero è fallito. Rifiutare i tavoli e riprovare.",
  "extra184": "La sessione POS è scaduta. Si prega di sbloccare nuovamente questo terminale.",
  "extra185": "Questa tavola è servita da una zona pranzo condivisa ma questo terminal non è stato autorizzato ad accedere alla vendita.",
  "extra186": "sessione POS scaduta o non autorizzata. Re-enter OTP e riprovare.",
  "extra187": "Non è possibile aprire il tavolo. Controllare la connettività e riprovare.",
  "extra188": "Pagamento fallito. Recuperare o scegliere un altro metodo.",
  "extra189": "Questo socio non ha le spese dell'account abilitate.",
  "extra190": "Si prega di selezionare un socio prima di caricare un account.",
  "extra191": "I soci non possono essere trovati.",
  "extra192": "Qualcosa e' andato storto, per favore riprovate.",
  "extra193": "Più elementi corrispondono a questo codice a barre",
  "extra194": "Codice a barre non riconosciuto",
  "extra195": "Selezionare una tabella per iniziare.",
  "extra196": "Toccare gli elementi del menu per iniziare una vendita.",
  "extra197": "Inviato in cucina",
  "extra198": "Trasferimenti in cucina",
  "extra199": "Vendita libera",
  "extra200": "Confermare l'invio",
  "extra201": "Terminale POS",
  "extra202": "Accedi",
  "extra203": "POS è offline. Controlla la connettività e riprova.",
  "extra204": "Piano piano non poteva essere caricato. Piastrelle sono ancora disponibili.",
  "extra206": "PIN è ambiguo, chiedere al manager di resettare un PIN.",
  "extra207": "PIN non riconosciuto per questo outlet.",
  "extra208": "Non è possibile accedere. Controllare la connettività e riprovare.",
  "extra209": "Non è possibile avviare una nuova vendita. Controllare la connettività e riprovare.",
  "extra210": "Non è possibile aggiungere elemento. Connessione persa.",
  "extra211": "Vendita non ancora pronta",
  "extra212": "Non è possibile rimuovere l'elemento. Connessione persa.",
  "extra213": "Non è possibile aggiornare la quantità. Connessione persa.",
  "extra214": "Incapace di liberare la vendita. Connessione persa.",
  "extra215": "Registrazione di pagamento in contanti...",
  "extra216": "Pagamento con successo",
  "extra217": "Lettore disconnesso. Ricollegamento e riprovazione.",
  "extra220": "Nessun lettore registrato per questa posizione in Stripe .",
  "extra221": "Nessun lettore simulato disponibile. Abilitare il lettore simulato e riprovare.",
  "extra222": "La posizione del terminale non è configurata per questa uscita.",
  "extra224": "Stripe Terminal SDK manca i metodi di pagamento. Ricaricare il terminale e riprovare.",
  "extra225": "Il lettore è occupato. Scollegare la sessione attiva e riprovare.",
  "extra228": "Non è stato possibile connettersi al lettore. Controllare la rete o riavviare il lettore.",
  "extra229": "L'account di ricavi POS non è configurato per questo oggetto/club.",
  "extra230": "La carta è diminuita.",
  "extra231": "Non poteva connettersi a Stripe Terminal. Controllare la rete e riprovare.",
  "extra232": "Selezionare una tabella prima di inviare in cucina.",
  "extra233": "Invio in cucina...",
  "extra234": "Ho gia' mandato in cucina.",
  "extra235": "Inviato in cucina.",
  "extra237": "Preparare il lettore...",
  "extra238": "Collegamento del lettore...",
  "extra239": "Questa presa non ha Stripe posizione del Terminal configurato.",
  "extra240": "Alla scoperta di lettori simulati...",
  "extra241": "Alla scoperta del lettore...",
  "extra242": "Nessun lettore simulato disponibile.",
  "extra243": "Collegamento al lettore...",
  "extra244": "Stripe Terminal SDK metodi di pagamento mancanti.",
  "extra245": "Raccogliere il metodo di pagamento...",
  "extra246": "Intenzioni di pagamento mancanti.",
  "extra247": "Elaborazione di pagamento...",
  "extra248": "L'elaborazione dei pagamenti è fallita.",
  "extra249": "Approvazione",
  "extra250": "Selezionare un socio da addebitare.",
  "extra251": "Conto socio di carica...",
  "extra252": "Aggiunto al conto socio",
  "extra253": "L'addebito dell'account è fallito. Recupera o scegli un altro metodo.",
  "extra254": "Non è in grado di applicare il socio.",
  "extra255": "La vendita non è ancora pronta.",
  "extra256": "Iscritto non trovato. Controllare il numero e riprovare.",
  "extra257": "Non è possibile rimuovere il socio.",
  "extra258": "Incapace di non disegnare il tavolo. Connessione persa.",
  "extra259": "Pronto",
  "extra260": "Nessuna tabella selezionata",
  "extra261": "Toccare per aggiungere · Tenere premuto per modificatori",
  "extra262": "Disponibile",
  "extra263": "Utilizzare codice a barre / ricerca dagli strumenti terminali.",
  "extra264": "Arrivo presto",
  "extra265": "Addebito dell'account",
  "extra266": "Modelli",
  "extra267": "Biblioteca",
  "extra268": "Proprietà",
  "extra269": "Premium touch-first modello di schermo POS.",
  "extra270": "Tutte le prese",
  "extra271": "Non assegnato",
  "extra272": "Questo modello non è attualmente assegnato a eventuali prese.",
  "extra273": "Prodotto mancante",
  "extra274": "Prodotto",
  "extra275": "Pulsante",
  "extra276": "Creare o selezionare un modello di progetto prima di utilizzare Privana Assist.",
  "extra277": "Privana Assist può aggiornare solo i modelli di bozza. Duplicare questo modello per creare una versione modificabile.",
  "extra278": "Descrivi un layout; nessuna schermata POS dal vivo cambia fino a quando non si esamina e applicarlo.",
  "extra280": "Continua",
  "extra281": "Che tipo di presa stai progettando?",
  "extra282": "Sembra giusto.",
  "extra284": "Privana ha progettato questo layout",
  "extra285": "Aggiornato",
  "extra286": "Nuovo",
  "extra287": "Applicare atomicamente...",
  "extra288": "Utilizzare questo layout",
  "extra289": "Proposta pronta per la revisione.",
  "extra290": "Privana Assist è stato cancellato o aggiornato. Il modello è invariato.",
  "extra291": "Privana Assist non ha potuto preparare una proposta sicura. Il vostro modello è invariato.",
  "extra292": "Privana generazione assist annullata. Il modello è invariato.",
  "extra293": "La proposta non poteva essere annullata.",
  "extra294": "La proposta non poteva essere annullata prima della rigenerazione.",
  "extra295": "La proposta non poteva essere annullata prima di cambiare i prodotti.",
  "extra296": "Layout applicato. Il modello rimane una bozza fino a quando non lo pubblichi.",
  "extra297": "La proposta non potrebbe essere applicata, non sono state apportate modifiche.",
  "extra307": "Assegnato",
  "extra308": "I suoi obiettivi globali",
  "extra309": "Fallback della Legacy",
  "extra312": "Nessun modello selezionato",
  "extra313": "Creare una pagina",
  "extra315": "Nessun modello",
  "extra316": "Inserire il codice una volta dal manager",
  "extra317": "Verifica del codice...",
  "extra318": "Accesso al terminale richiesto",
  "extra319": "Stati soci",
  "extra320": "Guardando...",
  "extra321": "Applica",
  "extra331": "Generale",
  "extra332": "Zona pranzo",
  "extra334": "Tabella",
  "extra340": "Piano terra non ancora impostato. Utilizzare la gestione del pranzo per crearne uno.",
  "extra345": "Piano terra da pranzo",
  "search": "Cerca...",
  "outletTypes": {
    "bar": "Bar",
    "dining": "Ceneri",
    "pro_shop": "Negozio Pro",
    "halfway_house": "Casa a metà strada"
  },
  "setupModes": {
    "stock_only": "Solo",
    "simple_product": "Semplice prodotto acquistato e venduto as-is",
    "draft_beer": "Bozza di birra / bevanda misurata",
    "food_recipe": "Ricetta / prodotto alimentare"
  },
  "actions": {
    "open_tables": "Tavoli aperti",
    "search_products": "Ricerca di prodotti",
    "member_lookup": "Ricerca di soci",
    "open_tabs": "Aprire le schede",
    "discounts": "Sconti",
    "refunds": "Rimborsi",
    "transfer_table": "Tabella di trasferimento",
    "split_bill": "Dividere la fattura",
    "print_bill": "Stampare la fattura"
  },
  "dynamic": {
    "todays_specials": "Le specialità di oggi",
    "happy_hour": "Articoli dell'ora felice",
    "top_sellers": "I migliori venditori",
    "recently_sold": "Venduto recentemente",
    "low_stock": "Basso stock"
  },
  "devices": {
    "tablet10": "10 pollici compressa",
    "terminal15": "Terminale da 15 pollici",
    "desktop": "Terminale desktop",
    "landscapeTablet": "Tablet di paesaggio"
  },
  "statuses": {
    "open": "Aperto",
    "pending": "In attesa",
    "pending_payment": "Pagamento anticipato",
    "sent_to_kitchen": "Inviato in cucina",
    "unpaid": "Non pagato",
    "paid": "Pagato",
    "completed": "Completato",
    "void": "Annullato",
    "voided": "Voi stessi",
    "refunded": "Rimborsato",
    "partially_refunded": "Rimborso parziale",
    "cancelled": "Annullato",
    "failed": "Non riuscito",
    "processing": "Elaborazione",
    "succeeded": "Successo",
    "active": "Attivo",
    "inactive": "Inattivo",
    "draft": "Bozza",
    "published": "Pubblicato",
    "archived": "Archiviato",
    "standard": "Standard",
    "enhanced": "Migliorata",
    "cash": "Contanti",
    "card": "Carta di carta",
    "card_present": "Carte regalo",
    "member_account": "Conto socio",
    "member_charge": "Tassa di soggiorno",
    "consumed": "Comprese",
    "settled": "Saldato",
    "partially_paid": "Parzialmente pagato",
    "closed": "Chiuso",
    "posted": "Contabilizzato",
    "not_posted": "Non pubblicato",
    "not_required": "Non richiesto",
    "sale": "Vendita",
    "refund": "Rimborso",
    "pos_sale": "Vendita POS",
    "pos_void": "Vuoto pOS",
    "pos_refund": "Rimborso POS",
    "warning": "Avvertenza",
    "applied": "Applicato",
    "deducted": "Dedotto",
    "not_costed": "Non costato",
    "pending_cost": "Costo di prestito",
    "reversed": "Stornato",
    "partially_settled": "Parzialmente saldato",
    "authorized": "Autorizzato",
    "sent": "Inviato",
    "partially_sent": "Invio parziale",
    "build": "Costruzioni",
    "improve": "Miglioramento",
    "partial": "Parziale"
  },
  "units": {
    "each": "ciascuno",
    "ml": "ml",
    "L": "L",
    "g": "g",
    "kg": "kg",
    "bottle": "bottiglia",
    "case": "caso",
    "keg": "barile",
    "barrel": "barile",
    "packages": "pacchetti",
    "package": "pacchetto",
    "stock": "stock"
  },
  "runtime": {
    "noItems": "Nessun menu configurato.",
    "searchHelp": "Cerca tutti i prodotti attivi per questo club e aggiungi direttamente alla vendita corrente.",
    "searchPlaceholder": "Ricerca di bevande, cibo, vendita al dettaglio...",
    "searchUnavailable": "Cercare non disponibile.",
    "searching": "Sto cercando...",
    "noMatches": "Nessun prodotto di corrispondenza.",
    "startTyping": "Inizia a digitare per i prodotti di ricerca.",
    "search": "Cerca",
    "home": "Casa",
    "folder": "Cartella",
    "emptyPage": "Questa pagina progettata non ha ancora pulsanti.",
    "emptyFolder": "Questa cartella non ha ancora pulsanti.",
    "unavailable": "Questa funzione non è ancora disponibile.",
    "unavailableLabel": "{label}, a breve, non disponibile",
    "codeDigit": "Codice cifra {digit}"
  },
  "recipe": {
    "packaged": "{name} è fornito come {size} {packageUnit} {unit}; l'uso della ricetta può essere inserito in {units} .",
    "incompatible": "{name} utilizza {unit}; scegli un'unità compatibile."
  },
  "messages": {
    "orderCheck": "Ordine e controllo",
    "tableMemberGuest": "Tabella/socio/ospite",
    "defaultMenu": " • Menu predefinito: {name}",
    "default": "Predefinito {name}",
    "assignedCount": "Assegnato a {count} outlet(i)",
    "stocked": "Archiviato in: {size} {packageUnit} {unit}",
    "removeStaff": "Rimuovere {name} da ePOS? Il loro account principale del personale rimarrà attivo.",
    "linkedOne": "Questo prodotto è collegato uno a uno con {name} .",
    "schema": "Lo schema del prodotto ePOS/recipe è ancora in fase di migrazione.",
    "genericError": "Incapace di completare questa azione. Si prega di riprovare.",
    "unassign": "Unassign tavolo {name}",
    "clearing": "Sgombrare...",
    "sending": "Invio…",
    "checking": "Controllare...",
    "added": "Aggiunto {name}",
    "kitchenNotified": "Inviato in cucina · {count} stazione(i) notificata.",
    "kitchenFailed": "Non è possibile avvisare la cucina. Controllare la connettività e riprovare.",
    "table": "Tabella {name}",
    "seats": "{count} posti",
    "generating": "Generando...",
    "select": "Seleziona {name}",
    "templateAssigned": "Questo modello è attualmente assegnato a {count} assegnazioni di uscita (s): {names} .",
    "thinkRetail": "Penso che tu stia progettando un {name} .",
    "designedRetail": "Privana progettato questo schermo per un {name}",
    "pageNumber": "Articolo {number}",
    "deletePage": "Cancella {name} ? {count} pulsante cartella (s) ({folders} ) attualmente aprire questa pagina progettata. Se si continua, quelle cartelle cadranno al loro layout auto nodo bambino.",
    "openPanel": "Pannello aperto {name}",
    "showSummary": "Mostra {name} sommario",
    "unlinked": "{name} non collegati",
    "selectTable": "Seleziona la tabella {name}",
    "sku": "SKU {sku}",
    "taxRate": "Tasse {rate}",
    "unitsOr": " o ",
    "recipeQty": " / Ricetta {quantity} {unit}"
  },
  "tax": {
    "noCode": "Nessun codice fiscale",
    "loading": "Caricamento dei codici fiscali...",
    "select": "Selezionare il codice fiscale",
    "unavailable": "Codici fiscali non disponibili"
  },
  "retail": {
    "golf_pro_shop": "Pro shop golf",
    "main_bar": "Bar principale",
    "restaurant": "Ristorante",
    "halfway_house": "Casa a metà strada",
    "coffee_shop": "Negozio di caffè",
    "spa_retail": "Vendita al dettaglio spa",
    "golf_academy": "Campo da golf",
    "tennis_shop": "Negozio di tennis",
    "padel_shop": "Negozio di padel",
    "fitness_reception": "Ricezione fitness",
    "marina_shop": "Negozio di Marina",
    "generic_retail": "Vendita al dettaglio",
    "other": "Altro"
  },
  "priorities": {
    "Fast checkout": "Checkout veloce",
    "Repeat purchases": "Ripetere gli acquisti",
    "Premium equipment browsing": "Navigazione di attrezzature premium",
    "Upselling accessories": "Accessori per il montaggio",
    "Fast service": "Servizio rapido",
    "Popular drinks": "Bevande popolari",
    "Simple staff navigation": "Semplice navigazione del personale",
    "Fast table ordering": "Ordinazione rapida della tabella",
    "Clear courses": "Corsi obbligatori",
    "Add-on visibility": "Visibilità aggiuntiva",
    "Grab-and-go purchases": "Acquisti di acquisto",
    "Drink customisation": "Personalizzazione della bevanda",
    "Food add-ons": "Additivi alimentari",
    "Premium presentation": "Presentazione Premium",
    "Simple product discovery": "Semplice scoperta del prodotto",
    "Fast booking": "Prenotazione veloce",
    "Clear coaching options": "Opzioni di coaching chiare",
    "Equipment browsing": "Attrezzatura di navigazione",
    "Essential supplies": "Forniture essenziali",
    "Clear categories": "Categorie chiare"
  },
  "objectives": {
    "Fastest Checkout": "Checkout più veloce",
    "Increase Retail Sales": "Aumentare le vendite al dettaglio",
    "Premium Merchandising": "Merchandising Premium",
    "Self-Service Friendly": "Auto-servizio amichevole",
    "Fast Staff Training": "Formazione del personale veloce"
  },
  "metrics": {
    "Pages affected": "Pagine interessate",
    "New pages": "Nuove pagine",
    "Updated pages": "Pagine aggiornate",
    "New folders": "Nuove cartelle",
    "Unique products": "Prodotti unici",
    "Home shortcuts": "Scorciatoie di casa",
    "Actions": "Azioni",
    "Deletions": "Eliminazioni"
  },
  "fragments": {
    "message0": "{v0} ricerca",
    "message1": "Predefinito {v0}",
    "message2": " • Menu predefinito: {v0}",
    "message3": "Assegnata a {v0} outlet {v1}",
    "message4": "SKU {v0}",
    "message5": "Tasse {v0}",
    "message6": "Questo prodotto è collegato uno a uno con {v0} .",
    "message7": "Unassign tavolo {v0}",
    "message8": "Aggiunto {v0}",
    "message9": "{v0} Tabella {v1}",
    "message10": "{v0} posti",
    "message11": "Questo modello è attualmente assegnato a {v0} incarico di uscita {v1}: {v2} .",
    "message12": "Cancella {v0} ? {v1} pulsante cartella {v2} ( {v3} ) attualmente aprire questa pagina progettata. Se si continua, quelle cartelle cadranno al loro layout auto nodo bambino.",
    "message13": "Pannello aperto {v0}",
    "message14": "{v0}, a breve, non disponibile",
    "message15": "Mostra {v0} sommario",
    "message16": "{v0} non collegati",
    "message17": "Seleziona la tabella {v0}",
    "message18": "Tabella {v0}"
  },
  "nodeTypes": {
    "product": "Prodotto",
    "folder": "Cartella",
    "action": "Azione",
    "dynamic": "Dinamica"
  }
};
